export const getVariantPriceWithout = (variant: GQL.IProductVariant, currency: GQL.ICurrency) => {
    // ošetření
    if (!variant || !currency) {
        return null;
    }

    // objekt cen
    const prices = variant && variant.product && variant.product.prices || null;

    // projdu ceny
    if (prices) {
        const price = prices.reduce((acc: GQL.IPrice | null, price: GQL.IPrice) => {
            if (price.currencyId === currency.id) {
                acc = price;
                if (price.productVariantId === variant.id) {
                    acc = price;
                }
            }
            return acc;
        }, null);

        if (price) {
            return price.priceWithout;
        }
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/helpers/Prices/getVariantPriceWithout.ts